import { connect } from 'react-redux';
import { updateUserSettings } from '../../store/actions/userSettings';
import UserSettings from '../../components/Pages/UserSettings';

const mapStateToProps = state => {

    // console.log( 'containers.Pages.UserSettings.mapStateToProps', state );

    return { userSettings: state.userSettings };

};

const mapDispatchToProps = dispatch => {

    return {
        onUpdateUserSettings: userSettings => dispatch( updateUserSettings( userSettings ) )
    };

};

export default connect( mapStateToProps, mapDispatchToProps )( UserSettings );